import { Injectable } from '@angular/core';
import { RefreshTokenService } from './refresh.service';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import 'rxjs/add/observable/throw';

import {
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpHandler,
} from '@angular/common/http';

import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/do';

@Injectable()
export class HttpResponseInterceptorService implements HttpInterceptor {
  isGeneratingToken: boolean = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  constructor(private _router: Router, private _refreshTokenService: RefreshTokenService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next
      .handle(request)
      .catch(response => {

        if (response instanceof HttpErrorResponse) {
          if (response.status == 401) {
            if (!this.isGeneratingToken) {
              this.isGeneratingToken = true;
              const refreshToken = this._refreshTokenService.getRefreshToken();
              if (refreshToken) {
                return this._refreshTokenService.refreshToken(refreshToken)
                  .mergeMap((auth: any) => {

                    if (auth && auth.token) {

                      this.tokenSubject.next(auth.token);
                      this._refreshTokenService.saveJWTToken(auth.token, auth.expiration);

                      request = request.clone({
                        setHeaders: {
                          Authorization: `Bearer ${auth.token}`
                        }
                      });

                      return next.handle(request);

                    } else {
                      this._router.navigate(['account/auth']);
                      return Observable.throw('Unauthorized');
                    }

                  })
                  .catch(error => {
                    this._router.navigate(['account/auth']);
                    return Observable.throw('Unauthorized');
                  })
                  .finally(() => {
                    this.isGeneratingToken = false;
                  });

              } else {
                this.isGeneratingToken = false;
                this._router.navigate(['account/auth']);
                return Observable.throw('Unauthorized');
              }
            } else {
              return this.tokenSubject.filter(token => token != null)
                .take(1)
                .switchMap(token => {
                  request = request.clone({
                    setHeaders: {
                      Authorization: `Bearer ${token}`
                    }
                  });

                  return next.handle(request);
                });
            }
          }
        }
        return Observable.throw(response);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/httpResponseInterceptor.service.ts